<template>
    <div class="config-field">
        <div class="tabs">
            <div
                v-for="tab in tabList"
                :key="tab.id"
                :class="[
                    {active: currentTab === tab.id},
                    'tab'
                ]"
                @click="alterTab($event, tab)"
            >
                {{ tab.label }}
            </div>
        </div>
        <div class="info">
            <hc-form ref="form" :model="currentMockObject.objectEntity" :rules="objectRules">
                <hc-form-item v-for="item in infos" :key="item.type" :label="item.label" :prop="item.type">
                    <hc-input v-model="(currentMockObject.objectEntity || {})[item.type]" />
                </hc-form-item>
            </hc-form>
        </div>
        <div class="table">
            <hc-table :data="tableData">
                <hc-table-column
                    v-for="(item, index) in tableHeaderInfo"
                    :key="item.id"
                    :prop="item.id"
                    min-width="160px"
                    show-overflow-tooltip
                >
                    <template slot="header" slot-scope="{ column }">
                        <div :class="[
                            'header__item',
                            { active: editFieldVisible && popperIndex === index }
                        ]"
                        >
                            <img class="type-icon" :src="componentsIcon[tableHeaderInfoForObj[item.id].config.defaultComponent]" alt="">
                            <span class="title">{{ (tableHeaderInfoForObj[item.id] || {}).title }}</span>
                            <!-- value：当点击的是当前列且显示弹窗时才展示 -->
                            <hc-popover
                                width="600"
                                trigger="manual"
                                placement="bottom"
                                popper-class="mock-edit-field-popover"
                                :value="editFieldVisible && popperIndex === index"
                            >
                                <hc-form
                                    :ref="`form${index}`"
                                    :rules="rulesObj"
                                    label-width="100px"
                                    :model="apiParamObj"
                                    label-position="left"
                                >
                                    <hc-form-item
                                        label="名称"
                                        prop="title"
                                    >
                                        <hc-input
                                            v-model.trim="apiParamObj.title"
                                            type="text"
                                            placeholder="请输入字段名称"
                                            size="small"
                                        />
                                    </hc-form-item>
                                    <hc-form-item
                                        label="ID"
                                        prop="name"
                                    >
                                        <hc-input
                                            v-model.trim="apiParamObj.name"
                                            type="text"
                                            placeholder="请输入字段 ID"
                                            size="small"
                                        />
                                    </hc-form-item>
                                    <hc-form-item
                                        label="类型"
                                        prop="type"
                                        :rules="[
                                            { required: true, message: '请选择字段类型', trigger: ['blur'] },
                                        ]"
                                    >
                                        <hc-select
                                            v-model.trim="currentType"
                                            placeholder="请选择" size="small"
                                            @change="changeFieldTypeFn"
                                        >
                                            <hc-option
                                                v-for="ct in typeArr"
                                                :key="ct.type"
                                                :label="ct.title"
                                                :value="ct.type"
                                            />
                                        </hc-select>
                                    </hc-form-item>
                                    <object-detail-type-form
                                        :ref="`objectDetailTypeForm${index}`"
                                        v-model="apiParamObj.config"
                                        :field-type="apiParamObj.type"
                                    />
                                </hc-form>
                                <div class="popover__footer">
                                    <hc-button @click="cancelEditField(index)">
                                        取消
                                    </hc-button>
                                    <hc-button type="primary" @click="editFieldSuccessCb(index)">
                                        确定
                                    </hc-button>
                                </div>
                                <hc-button
                                    slot="reference"
                                    type="text"
                                    icon="el-icon-caret-bottom"
                                    @click="toEditField(column,index)"
                                />
                            </hc-popover>
                        </div>
                    </template>
                    <template slot-scope="{ row }">
                        {{ getRowValue(row, item) }}
                    </template>
                </hc-table-column>
            </hc-table>
        </div>
    </div>
</template>
<script>
import _ from 'lodash'
import { mapActions } from 'vuex'

import * as T from '@common/store/app-resource/types'
import { APP_RESOURCE } from '@common/store/module-types'

import ObjectMixin from '../../object-mixin'
import fieldMixin  from '../../field-mixin'
import {
    MockType,
    ObjectFieldType,
    componentsIcon,
} from '../../const'
import ObjectDetailTypeForm from '../../object-detail-type-form'

export default {
    name: 'ConfigField',
    components: {
        ObjectDetailTypeForm,
    },
    mixins: [fieldMixin, ObjectMixin],
    props: {
        data: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            componentsIcon,
            // 当前选中 tab
            currentTab: '',
            // 接口拿来的所有当前页信息
            allInfo: this.data,
            // 表格数据
            tableData: [],
            // 表格头信息，动态渲染
            tableHeaderInfo: [],
            // 当前编辑的字段信息
            apiParamObj: {
                type: 'string',
                config: {},
            },
            typeArr: MockType,
            // editFieldVisible 和 popperIndex 控制弹窗展示
            editFieldVisible: false,
            popperIndex: -1,
            // 简单描述
            infos: [
                { label: '显示名称', type: 'title' },
                { label: ' 对象名称', type: 'name' },
            ],
        }
    },
    computed: {
        // 头部信息转 obj，通过 key 快速获取
        tableHeaderInfoForObj() {
            const { tableHeaderInfo } = this
            return tableHeaderInfo.reduce((all, item) => ({
                ...all,
                [item.id]: {
                    ...item,
                },
            }), {})
        },
        // 顶部tab🈶页信息
        tabList() {
            return this.allInfo.reduce((all, item) => [
                ...all,
                { label: item.tabName, id: item.tabName },
            ], [])
        },
        currentMockObject() {
            return (this.allInfo.find(item => item.tabName === this.currentTab) || {}).mockObject || {}
        },
        // 真实字段类型的抽象分类
        currentType: {
            get() {
                return this.getType(this.apiParamObj.type)
            },
            set(value) {
                this.apiParamObj.type = value
            },
        },
    },
    watch: {
        'apiParamObj.config': {
            deep: true,
            handler(value) {
                if (!value) return
                this.$nextTick(() => {
                    this.apiParamObj.type = value.type
                })
            },
        },
    },
    mounted() {
        this.init()
    },
    methods: {
        ...mapActions(APP_RESOURCE, {
            uploadMockExcell: T.UPLOAD_MOCK_EXCELL,
            getMockTemplate: T.GET_MOCK_TEMPLATE,
        }),
        init() {
            this.currentTab = this.allInfo[0].tabName
            const { objectEntity = {}, dataItems } = this.currentMockObject || {}
            this.tableData = dataItems
            this.tableHeaderInfo = objectEntity.items || []
        },
        getRowValue(row, column) {
            const rowValue = row[column.id]
            // 值为 undefined 或为 '' 展示 --，对布尔（false）、数字（0）做兼容支持展示
            return typeof rowValue === 'undefined' || rowValue === ''
                ? '--'
                : rowValue
        },
        getType(cType) {
            return (ObjectFieldType.find(type => type.name === cType) || {}).type
        },
        // 下一步时，获取字段信息，用于父级调用
        getFields() {
            return _.cloneDeep({
                ...this.currentMockObject.objectEntity,
                items: _.cloneDeep(this.tableHeaderInfo),
            })
        },
        // 编辑字段，打开弹窗、初始化信息
        toEditField(item, index) {
            // 切换功能，如果开着弹窗点击关闭
            if (this.editFieldVisible) {
                this.cancelEditField(index)
                return
            }
            const { property } = item
            const defaultValue =  _.cloneDeep(this.tableHeaderInfoForObj[property] || {})
            if (!defaultValue.config) {
                defaultValue.config = {}
            }
            this.apiParamObj = defaultValue
            this.popperIndex = index
            this.editFieldVisible = true
        },
        changeFieldTypeFn() {
            this.$set(this.apiParamObj, 'defaultValue', '')
        },
        // 切换 tab
        alterTab(e, item) {
            const { id } = item
            this.currentTab = id
            if (e && e.target) {
                // 滚动居中
                e.target.scrollIntoView({
                    behavior: 'smooth',
                    inline: 'center',
                })
            }
        },
        // 关闭字段编辑弹窗
        cancelEditField(index) {
            this.editFieldVisible = false
            this.popperIndex = -1
            this.$refs[`form${index}`][0].clearValidate()
            this.$refs[`objectDetailTypeForm${index}`][0].clearValidate()
        },
        // 校验显示名称、对象名称
        validateObject() {
            return this.$refs.form.validate()
        },
        // 校验每个字段的表单
        validateForm(index) {
            return new Promise((resolve, reject) => {
                Promise.all([
                    this.$refs[`objectDetailTypeForm${index}`][0].validateChildForm(),
                    this.$refs[`form${index}`][0].validate(),
                ])
                    .then(() => resolve())
                    .catch(() => reject(index))
            })
        },
        // 编辑字段成功回调
        editFieldSuccessCb(index) {
            this.rulesObj = {
                ...this.defaultValRules,
                ...this.rulesObj,
            }
            this.validateForm(index)
                .then(() => {
                    const field = this.apiParamObj
                    this.$set(this.tableHeaderInfo, index, field)
                    this.cancelEditField(index)
                })
        },
    },
}
</script>
<style lang="less" scoped>
.config-field {
    border-radius: 3px;
    border: 1px solid #DDD;
    .tabs {
        width: 100%;
        display: flex;
        overflow-x: auto;
        .tab {
            flex-shrink: 0;
            color: #666;
            cursor: pointer;
            font-size: 12px;
            line-height: 20px;
            padding: 10px 12px;
            position: relative;
            &.active {
                color: #222;
                &:after {
                    content: '';
                    display: block;
                    width: 24px;
                    height: 2px;
                    position: absolute;
                    bottom: 0;
                    left: 50%;
                    transform: translateX(-50%);
                    background: #266EFF;
                }
            }
        }
    }
    .info {
        display: flex;
        padding: 0 12px;
        margin-top: 16px;
        .hc-form {
            width: 100%;
            display: flex;
            .hc-form-item {
                flex: 1;
                margin: 0;
                display: flex;
                align-items: center;
                &:not(:first-child) {
                    margin-left: 40px;
                }
            }
            /deep/ .hc-form-item__content {
                flex: 1;
                line-height: 32px;
            }
            /deep/ .hc-form-item__label {
                padding: 0;
                color: #666;
                font-size: 12px;
                line-height: 20px;
                margin-right: 16px;
                &:before {
                    display: none;
                }
            }
        }
    }
    .table {
        margin-top: 16px;
        /deep/ .hc-table {
            .cell {
                padding: 0 16px;
            }
            th.hc-table__cell{
                background: #FBFBFB;
            }
        }
        /deep/ .header__item {
            display: flex;
            align-items: center;
            .type-icon {
                width: 16px;
                height: 16px;
            }
            .title {
                overflow: hidden;
                margin-left: 4px;
                white-space: nowrap;
                display: inline-block;
                text-overflow: ellipsis;
            }
            .hc-button--text {
                padding: 4px;
                border: none;
                flex-shrink: 0;
                margin-left: 4px;
                .el-icon-caret-bottom {
                    color: #666;
                    transition: all .3s ease;
                }
                &:hover {
                    background: #E9EBEE;
                }
                
            }
            &.active {
                .hc-button--text {
                    background: #E9EBEE;
                    .el-icon-caret-bottom {
                        color: #266EFF;
                        transform: rotate(180deg);
                    }
                }
            }
        }
    }
}
</style>
<style lang="less">
.hc-popover.mock-edit-field-popover {
    .hc-select {
        width: 100%;
    }
    .popover__footer {
        text-align: right;
        .hc-button {
            width: 80px;
        }
    }

    .hc-form {
        overflow-y: auto;
        max-height: 360px;
        overflow-x: hidden;
    }
}
</style>
